import { DEPOSIT_ACCOUNT_STATUS_DB } from '@/const/wire';
import PendingStatusIcon from '@/images/BlcStatusesIcons/PendingStatusIcon.svg?react';
import FailedStatusIcon from '@/images/BlcStatusesIcons/FailedStatusIcon.svg?react';
import { STATUS_VARIANT_HIGHLIGHT, StatusType } from '@/components/StatusWrapper/const';

export const STATUS_DEPOSIT_ACCOUNT_TEXT_DB = {
  [DEPOSIT_ACCOUNT_STATUS_DB.ACTIVE]: 'Active',
  [DEPOSIT_ACCOUNT_STATUS_DB.INACTIVE]: 'Inactive',
  [DEPOSIT_ACCOUNT_STATUS_DB.PENDING]: 'Pending',
  [DEPOSIT_ACCOUNT_STATUS_DB.FAILED]: 'Failed',
};

export const STATUS_DEPOSIT_ACCOUNT_MAP: StatusType = {
  [DEPOSIT_ACCOUNT_STATUS_DB.ACTIVE]: { variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  [DEPOSIT_ACCOUNT_STATUS_DB.INACTIVE]: { variant: STATUS_VARIANT_HIGHLIGHT.RED },
  [DEPOSIT_ACCOUNT_STATUS_DB.PENDING]: {
    variant: STATUS_VARIANT_HIGHLIGHT.BLUE,
    statusIcon: <PendingStatusIcon />,
  },
  [DEPOSIT_ACCOUNT_STATUS_DB.FAILED]: {
    variant: STATUS_VARIANT_HIGHLIGHT.RED,
    statusIcon: <FailedStatusIcon />,
  },
};
